import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "floating-header" }
const _hoisted_2 = { class: "floating-header__actions" }
const _hoisted_3 = {
  class: "drag-handle",
  title: "Drag to move"
}
const _hoisted_4 = { class: "floating-body" }

import { ref } from "vue";
import { Icon } from "@iconify/vue";
import TemplateViewerModal from "./TemplateViewerModal.vue";
import { useDraggable } from "@/composables/ui/useDraggable";


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplatesFloatingModal',
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {




const isPreviewOpen = ref(false);

const { modalRef, isDragging, isInitialPosition, style, startDrag } = useDraggable({
  initialWidth: 480,
  initialHeight: 640,
  excludedSelectors: [
    ".floating-body",
    "button",
    "a",
    "input",
    "textarea",
    "[contenteditable]",
    ".ql-toolbar",
    ".ql-editor",
  ],
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "templates-floating-fade" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["templates-floating-overlay", { 'dragging-active': !_unref(isInitialPosition) }])
          }, [
            _withDirectives(_createElementVNode("div", {
              ref_key: "modalRef",
              ref: modalRef,
              class: _normalizeClass(["templates-floating-panel", { 'is-dragging': _unref(isDragging) }]),
              style: _normalizeStyle(_unref(style)),
              role: "dialog",
              "aria-label": "Template Viewer",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              onMousedown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(startDrag) && _unref(startDrag)(...args))),
              onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(startDrag) && _unref(startDrag)(...args)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "floating-header__text" }, [
                  _createElementVNode("h6", { class: "floating-header__title" }, "Template Viewer"),
                  _createElementVNode("p", { class: "floating-header__subtitle" }, "Drag to move · browse and copy templates")
                ], -1)),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:drag",
                      width: "16",
                      height: "16"
                    })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "floating-close-btn",
                    "aria-label": "Close templates",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: "mdi:close",
                      width: "18",
                      height: "18"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(TemplateViewerModal, {
                  "hide-header": true,
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                  onPreviewChange: _cache[2] || (_cache[2] = ($event: any) => (isPreviewOpen.value = $event))
                })
              ])
            ], 38), [
              [_vShow, !isPreviewOpen.value]
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})